import { DomainList } from '../typings';

export const more: DomainList = [
  'aim.com',
  'bellatlantic.net',
  'citlink.net',
  'compuserve.com',
  'cs.com',
  'frontier.com',
  'frontiernet.net',
  'games.com',
  'goowy.com',
  'gte.net',
  'love.com',
  'netscape.net',
  'rocketmail.com',
  'rogers.com',
  'sky.com',
  'verizon.net',
  'verizon.net.in',
  'wild4music.com',
  'wmconnect.com',
  'wow.com',
  'y7mail.com',
  'ybb.ne.jp',
  'ygm.com',
  'ymail.com',
];

export default more;
